import * as actionType from "./constants";

const initialState = {
    getDynamicTablesResponse: null,
    getPublishedDynamicTablesResponse: null,
    getDynamicTableByIdResponse: null,
    addDynamicTableResponse: null,
    updateDynamicTableResponse: null,
    deleteDynamicTableResponse: null,
    getListForCommonFilterResponse: null,
    entityParams: {},

    getDynamicTableBandsResponse: null,
    addDynamicTableBandResponse: null,
    updateDynamicTableBandResponse: null,
    deleteDynamicTableBandResponse: null,
    getListForBandCommonFilterResponse: null,
    bandLoading: false,

    getDynamicTableFieldsResponse: null,
    getDynamicTableFieldsGroupedResponse: null,
    getDynamicTableFieldByIdResponse: null,
    addDynamicTableFieldResponse: null,
    updateDynamicTableFieldResponse: null,
    deleteDynamicTableFieldResponse: null,
    reorderDynamicTableFieldsResponse: null,
    getListForFieldCommonFilterResponse: null,

    getDynamicTableRecordsResponse: null,
    getDynamicTableRecordByIdResponse: null,
    addDynamicTableRecordResponse: null,
    updateDynamicTableRecordResponse: null,
    deleteDynamicTableRecordResponse: null,
    getListForRecordCommonFilterResponse: null,
    getRecordCommonDataResponse: null,
    recordCommonDataLoading: false,
    bulkEditRecordsLoading: false,

    getEntityDynamicTablesResponse: null,
    getAssignPickerRecordsResponse: null,
    getListForAssignPickerFilterResponse: null,
    bulkAssignRecordsResponse: null,
    bulkUnassignRecordsResponse: null,

    importValidationResponse: null,
    confirmImportResponse: null,
    importTemplateResponse: null,
    importValidationLoading: false,
    confirmImportLoading: false,
    importTemplateLoading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_DYNAMIC_TABLES_REQUEST:
            return { ...state, getDynamicTablesResponse: null };
        case actionType.GET_DYNAMIC_TABLES_SUCCESS:
            return { ...state, getDynamicTablesResponse: { success: true, ...action.response } };
        case actionType.GET_DYNAMIC_TABLES_FAILURE:
            return { ...state, getDynamicTablesResponse: { success: false, ...action.error } };

        case actionType.GET_PUBLISHED_DYNAMIC_TABLES_REQUEST:
            return { ...state, getPublishedDynamicTablesResponse: null };
        case actionType.GET_PUBLISHED_DYNAMIC_TABLES_SUCCESS:
            return { ...state, getPublishedDynamicTablesResponse: { success: true, ...action.response } };
        case actionType.GET_PUBLISHED_DYNAMIC_TABLES_FAILURE:
            return { ...state, getPublishedDynamicTablesResponse: { success: false, ...action.error } };

        case actionType.GET_DYNAMIC_TABLE_BY_ID_REQUEST:
            return { ...state, getDynamicTableByIdResponse: null };
        case actionType.GET_DYNAMIC_TABLE_BY_ID_SUCCESS:
            return { ...state, getDynamicTableByIdResponse: { success: true, ...action.response } };
        case actionType.GET_DYNAMIC_TABLE_BY_ID_FAILURE:
            return { ...state, getDynamicTableByIdResponse: { success: false, ...action.error } };

        case actionType.ADD_DYNAMIC_TABLE_REQUEST:
            return { ...state };
        case actionType.ADD_DYNAMIC_TABLE_SUCCESS:
            return { ...state, addDynamicTableResponse: { success: true, ...action.response } };
        case actionType.ADD_DYNAMIC_TABLE_FAILURE:
            return { ...state, addDynamicTableResponse: { success: false, ...action.error } };

        case actionType.UPDATE_DYNAMIC_TABLE_REQUEST:
            return { ...state };
        case actionType.UPDATE_DYNAMIC_TABLE_SUCCESS:
            return { ...state, updateDynamicTableResponse: { success: true, ...action.response } };
        case actionType.UPDATE_DYNAMIC_TABLE_FAILURE:
            return { ...state, updateDynamicTableResponse: { success: false, ...action.error } };

        case actionType.DELETE_DYNAMIC_TABLE_REQUEST:
            return { ...state };
        case actionType.DELETE_DYNAMIC_TABLE_SUCCESS:
            return { ...state, deleteDynamicTableResponse: { success: true, ...action.response } };
        case actionType.DELETE_DYNAMIC_TABLE_FAILURE:
            return { ...state, deleteDynamicTableResponse: { success: false, ...action.error } };

        case actionType.GET_LIST_FOR_DYNAMIC_TABLE_FILTER_REQUEST:
            return { ...state };
        case actionType.GET_LIST_FOR_DYNAMIC_TABLE_FILTER_SUCCESS:
            return { ...state, getListForCommonFilterResponse: { success: true, ...action.response } };
        case actionType.GET_LIST_FOR_DYNAMIC_TABLE_FILTER_FAILURE:
            return { ...state, getListForCommonFilterResponse: { success: false, ...action.error } };

        case actionType.GET_DYNAMIC_TABLE_BANDS_REQUEST:
            return { ...state, bandLoading: true };
        case actionType.GET_DYNAMIC_TABLE_BANDS_SUCCESS:
            return { ...state, bandLoading: false, getDynamicTableBandsResponse: { success: true, ...action.response } };
        case actionType.GET_DYNAMIC_TABLE_BANDS_FAILURE:
            return { ...state, bandLoading: false, getDynamicTableBandsResponse: { success: false, ...action.error } };

        case actionType.ADD_DYNAMIC_TABLE_BAND_REQUEST:
            return { ...state };
        case actionType.ADD_DYNAMIC_TABLE_BAND_SUCCESS:
            return { ...state, addDynamicTableBandResponse: { success: true, ...action.response }, getDynamicTableFieldsGroupedResponse: null };
        case actionType.ADD_DYNAMIC_TABLE_BAND_FAILURE:
            return { ...state, addDynamicTableBandResponse: { success: false, ...action.error } };

        case actionType.UPDATE_DYNAMIC_TABLE_BAND_REQUEST:
            return { ...state };
        case actionType.UPDATE_DYNAMIC_TABLE_BAND_SUCCESS:
            return { ...state, updateDynamicTableBandResponse: { success: true, ...action.response }, getDynamicTableFieldsGroupedResponse: null };
        case actionType.UPDATE_DYNAMIC_TABLE_BAND_FAILURE:
            return { ...state, updateDynamicTableBandResponse: { success: false, ...action.error } };

        case actionType.DELETE_DYNAMIC_TABLE_BAND_REQUEST:
            return { ...state };
        case actionType.DELETE_DYNAMIC_TABLE_BAND_SUCCESS:
            return { ...state, deleteDynamicTableBandResponse: { success: true, ...action.response }, getDynamicTableFieldsGroupedResponse: null };
        case actionType.DELETE_DYNAMIC_TABLE_BAND_FAILURE:
            return { ...state, deleteDynamicTableBandResponse: { success: false, ...action.error } };

        case actionType.GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_REQUEST:
            return { ...state };
        case actionType.GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_SUCCESS:
            return { ...state, getListForBandCommonFilterResponse: { success: true, ...action.response } };
        case actionType.GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_FAILURE:
            return { ...state, getListForBandCommonFilterResponse: { success: false, ...action.error } };

        case actionType.GET_DYNAMIC_TABLE_FIELDS_REQUEST:
            return { ...state, getDynamicTableFieldsResponse: null };
        case actionType.GET_DYNAMIC_TABLE_FIELDS_SUCCESS:
            return { ...state, getDynamicTableFieldsResponse: { success: true, ...action.response } };
        case actionType.GET_DYNAMIC_TABLE_FIELDS_FAILURE:
            return { ...state, getDynamicTableFieldsResponse: { success: false, ...action.error } };

        case actionType.GET_DYNAMIC_TABLE_FIELDS_GROUPED_REQUEST:
            return { ...state, getDynamicTableFieldsGroupedResponse: null };
        case actionType.GET_DYNAMIC_TABLE_FIELDS_GROUPED_SUCCESS:
            return { ...state, getDynamicTableFieldsGroupedResponse: { success: true, ...action.response } };
        case actionType.GET_DYNAMIC_TABLE_FIELDS_GROUPED_FAILURE:
            return { ...state, getDynamicTableFieldsGroupedResponse: { success: false, ...action.error } };

        case actionType.GET_DYNAMIC_TABLE_FIELD_BY_ID_REQUEST:
            return { ...state, getDynamicTableFieldByIdResponse: null };
        case actionType.GET_DYNAMIC_TABLE_FIELD_BY_ID_SUCCESS:
            return { ...state, getDynamicTableFieldByIdResponse: { success: true, ...action.response } };
        case actionType.GET_DYNAMIC_TABLE_FIELD_BY_ID_FAILURE:
            return { ...state, getDynamicTableFieldByIdResponse: { success: false, ...action.error } };

        case actionType.ADD_DYNAMIC_TABLE_FIELD_REQUEST:
            return { ...state };
        case actionType.ADD_DYNAMIC_TABLE_FIELD_SUCCESS:
            return { ...state, addDynamicTableFieldResponse: { success: true, ...action.response }, getDynamicTableFieldsGroupedResponse: null };
        case actionType.ADD_DYNAMIC_TABLE_FIELD_FAILURE:
            return { ...state, addDynamicTableFieldResponse: { success: false, ...action.error } };

        case actionType.UPDATE_DYNAMIC_TABLE_FIELD_REQUEST:
            return { ...state };
        case actionType.UPDATE_DYNAMIC_TABLE_FIELD_SUCCESS:
            return { ...state, updateDynamicTableFieldResponse: { success: true, ...action.response }, getDynamicTableFieldsGroupedResponse: null };
        case actionType.UPDATE_DYNAMIC_TABLE_FIELD_FAILURE:
            return { ...state, updateDynamicTableFieldResponse: { success: false, ...action.error } };

        case actionType.DELETE_DYNAMIC_TABLE_FIELD_REQUEST:
            return { ...state };
        case actionType.DELETE_DYNAMIC_TABLE_FIELD_SUCCESS:
            return { ...state, deleteDynamicTableFieldResponse: { success: true, ...action.response }, getDynamicTableFieldsGroupedResponse: null };
        case actionType.DELETE_DYNAMIC_TABLE_FIELD_FAILURE:
            return { ...state, deleteDynamicTableFieldResponse: { success: false, ...action.error } };

        case actionType.REORDER_DYNAMIC_TABLE_FIELDS_REQUEST:
            return { ...state };
        case actionType.REORDER_DYNAMIC_TABLE_FIELDS_SUCCESS:
            return { ...state, reorderDynamicTableFieldsResponse: { success: true, ...action.response }, getDynamicTableFieldsGroupedResponse: null };
        case actionType.REORDER_DYNAMIC_TABLE_FIELDS_FAILURE:
            return { ...state, reorderDynamicTableFieldsResponse: { success: false, ...action.error } };

        case actionType.GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_REQUEST:
            return { ...state };
        case actionType.GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_SUCCESS:
            return { ...state, getListForFieldCommonFilterResponse: { success: true, ...action.response } };
        case actionType.GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_FAILURE:
            return { ...state, getListForFieldCommonFilterResponse: { success: false, ...action.error } };

        case actionType.GET_DYNAMIC_TABLE_RECORDS_REQUEST:
            return { ...state, getDynamicTableRecordsResponse: null };
        case actionType.GET_DYNAMIC_TABLE_RECORDS_SUCCESS:
            return { ...state, getDynamicTableRecordsResponse: { success: true, ...action.response } };
        case actionType.GET_DYNAMIC_TABLE_RECORDS_FAILURE:
            return { ...state, getDynamicTableRecordsResponse: { success: false, ...action.error } };

        case actionType.GET_LIST_FOR_LINKED_ENTITY_FILTER_REQUEST:
            return { ...state };
        case actionType.GET_LIST_FOR_LINKED_ENTITY_FILTER_SUCCESS:
            return { ...state, getListForLinkedEntityFilterResponse: action.response };
        case actionType.GET_LIST_FOR_LINKED_ENTITY_FILTER_FAILURE:
            return { ...state, getListForLinkedEntityFilterResponse: { list: [], count: 0 } };

        case actionType.GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_REQUEST:
            return { ...state, getDynamicTableRecordLinkedEntitiesResponse: null };
        case actionType.GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_SUCCESS:
            return { ...state, getDynamicTableRecordLinkedEntitiesResponse: { success: true, ...action.response } };
        case actionType.GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_FAILURE:
            return { ...state, getDynamicTableRecordLinkedEntitiesResponse: { success: false, ...action.error } };

        case actionType.GET_DYNAMIC_TABLE_RECORD_TOTALS_REQUEST:
            return { ...state, getDynamicTableRecordTotalsResponse: null };
        case actionType.GET_DYNAMIC_TABLE_RECORD_TOTALS_SUCCESS:
            return { ...state, getDynamicTableRecordTotalsResponse: { success: true, ...action.response } };
        case actionType.GET_DYNAMIC_TABLE_RECORD_TOTALS_FAILURE:
            return { ...state, getDynamicTableRecordTotalsResponse: { success: false, ...action.error } };

        case actionType.GET_DYNAMIC_TABLE_RECORD_BY_ID_REQUEST:
            return { ...state, getDynamicTableRecordByIdResponse: null };
        case actionType.GET_DYNAMIC_TABLE_RECORD_BY_ID_SUCCESS:
            return { ...state, getDynamicTableRecordByIdResponse: { success: true, ...action.response } };
        case actionType.GET_DYNAMIC_TABLE_RECORD_BY_ID_FAILURE:
            return { ...state, getDynamicTableRecordByIdResponse: { success: false, ...action.error } };

        case actionType.ADD_DYNAMIC_TABLE_RECORD_REQUEST:
            return { ...state };
        case actionType.ADD_DYNAMIC_TABLE_RECORD_SUCCESS:
            return { ...state, addDynamicTableRecordResponse: { success: true, ...action.response } };
        case actionType.ADD_DYNAMIC_TABLE_RECORD_FAILURE:
            return { ...state, addDynamicTableRecordResponse: { success: false, ...action.error } };

        case actionType.UPDATE_DYNAMIC_TABLE_RECORD_REQUEST:
            return { ...state };
        case actionType.UPDATE_DYNAMIC_TABLE_RECORD_SUCCESS:
            return { ...state, updateDynamicTableRecordResponse: { success: true, ...action.response } };
        case actionType.UPDATE_DYNAMIC_TABLE_RECORD_FAILURE:
            return { ...state, updateDynamicTableRecordResponse: { success: false, ...action.error } };

        case actionType.DELETE_DYNAMIC_TABLE_RECORD_REQUEST:
            return { ...state };
        case actionType.DELETE_DYNAMIC_TABLE_RECORD_SUCCESS:
            return { ...state, deleteDynamicTableRecordResponse: { success: true, ...action.response } };
        case actionType.DELETE_DYNAMIC_TABLE_RECORD_FAILURE:
            return { ...state, deleteDynamicTableRecordResponse: { success: false, ...action.error } };

        case actionType.GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_REQUEST:
            return { ...state, recordCommonDataLoading: true, getRecordCommonDataResponse: null };
        case actionType.GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_SUCCESS:
            return { ...state, recordCommonDataLoading: false, getRecordCommonDataResponse: { success: true, ...action.response } };
        case actionType.GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_FAILURE:
            return { ...state, recordCommonDataLoading: false, getRecordCommonDataResponse: { success: false, ...action.error } };
        case actionType.RESET_DYNAMIC_TABLE_RECORD_COMMON_DATA:
            return { ...state, recordCommonDataLoading: false, getRecordCommonDataResponse: null };

        case actionType.BULK_EDIT_DYNAMIC_TABLE_RECORDS_REQUEST:
            return { ...state, bulkEditRecordsLoading: true };
        case actionType.BULK_EDIT_DYNAMIC_TABLE_RECORDS_SUCCESS:
        case actionType.BULK_EDIT_DYNAMIC_TABLE_RECORDS_FAILURE:
            return { ...state, bulkEditRecordsLoading: false };

        case actionType.BULK_DELETE_DYNAMIC_TABLE_RECORDS_REQUEST:
        case actionType.BULK_DELETE_DYNAMIC_TABLE_RECORDS_SUCCESS:
        case actionType.BULK_DELETE_DYNAMIC_TABLE_RECORDS_FAILURE:
            return { ...state };

        case actionType.GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_REQUEST:
            return { ...state };
        case actionType.GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_SUCCESS:
            return { ...state, getListForRecordCommonFilterResponse: { success: true, ...action.response } };
        case actionType.GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_FAILURE:
            return { ...state, getListForRecordCommonFilterResponse: { success: false, ...action.error } };

        case actionType.GET_ENTITY_DYNAMIC_TABLES_REQUEST:
            return { ...state, getEntityDynamicTablesResponse: null };
        case actionType.GET_ENTITY_DYNAMIC_TABLES_SUCCESS:
            return { ...state, getEntityDynamicTablesResponse: { success: true, ...action.response } };
        case actionType.GET_ENTITY_DYNAMIC_TABLES_FAILURE:
            return { ...state, getEntityDynamicTablesResponse: { success: false, ...action.error } };

        case actionType.GET_ASSIGN_PICKER_RECORDS_REQUEST:
            return { ...state, getAssignPickerRecordsResponse: null };
        case actionType.GET_ASSIGN_PICKER_RECORDS_SUCCESS:
            return { ...state, getAssignPickerRecordsResponse: { success: true, ...action.response } };
        case actionType.GET_ASSIGN_PICKER_RECORDS_FAILURE:
            return { ...state, getAssignPickerRecordsResponse: { success: false, ...action.error } };

        case actionType.GET_LIST_FOR_ASSIGN_PICKER_FILTER_REQUEST:
            return { ...state };
        case actionType.GET_LIST_FOR_ASSIGN_PICKER_FILTER_SUCCESS:
            return { ...state, getListForAssignPickerFilterResponse: { success: true, ...action.response } };
        case actionType.GET_LIST_FOR_ASSIGN_PICKER_FILTER_FAILURE:
            return { ...state, getListForAssignPickerFilterResponse: { success: false, ...action.error } };

        case actionType.BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_REQUEST:
            return { ...state, bulkAssignRecordsResponse: null };
        case actionType.BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_SUCCESS:
            return { ...state, bulkAssignRecordsResponse: { success: true, ...action.response } };
        case actionType.BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_FAILURE:
            return { ...state, bulkAssignRecordsResponse: { success: false, ...action.error } };

        case actionType.BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_REQUEST:
            return { ...state, bulkUnassignRecordsResponse: null };
        case actionType.BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_SUCCESS:
            return { ...state, bulkUnassignRecordsResponse: { success: true, ...action.response } };
        case actionType.BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_FAILURE:
            return { ...state, bulkUnassignRecordsResponse: { success: false, ...action.error } };

        case actionType.CLEAR_DYNAMIC_TABLE_ASSIGN_RESPONSES:
            return {
                ...state,
                getAssignPickerRecordsResponse: null,
                getListForAssignPickerFilterResponse: null,
                bulkAssignRecordsResponse: null,
                bulkUnassignRecordsResponse: null
            };

        case actionType.GET_DYNAMIC_TABLE_IMPORT_TEMPLATE_REQUEST:
            return { ...state, importTemplateLoading: true, importTemplateResponse: null };
        case actionType.GET_DYNAMIC_TABLE_IMPORT_TEMPLATE_SUCCESS:
            return { ...state, importTemplateLoading: false, importTemplateResponse: { success: true, ...action.response } };
        case actionType.GET_DYNAMIC_TABLE_IMPORT_TEMPLATE_FAILURE:
            return { ...state, importTemplateLoading: false, importTemplateResponse: { success: false, ...action.error } };

        case actionType.VALIDATE_DYNAMIC_TABLE_IMPORT_REQUEST:
            return { ...state, importValidationLoading: true };
        case actionType.VALIDATE_DYNAMIC_TABLE_IMPORT_SUCCESS:
            return { ...state, importValidationLoading: false, importValidationResponse: { success: true, ...action.response } };
        case actionType.VALIDATE_DYNAMIC_TABLE_IMPORT_FAILURE:
            return { ...state, importValidationLoading: false, importValidationResponse: { success: false, ...action.error } };

        case actionType.CONFIRM_DYNAMIC_TABLE_IMPORT_REQUEST:
            return { ...state, confirmImportLoading: true };
        case actionType.CONFIRM_DYNAMIC_TABLE_IMPORT_SUCCESS:
            return {
                ...state,
                confirmImportLoading: false,
                confirmImportResponse: { success: true, ...action.response },
                getDynamicTableFieldsGroupedResponse: null
            };
        case actionType.CONFIRM_DYNAMIC_TABLE_IMPORT_FAILURE:
            return { ...state, confirmImportLoading: false, confirmImportResponse: { success: false, ...action.error } };

        case actionType.CLEAR_DYNAMIC_TABLE_IMPORT_VALIDATION:
            return { ...state, importValidationResponse: null, confirmImportResponse: null, importTemplateResponse: null };

        case actionType.UPDATE_DYNAMIC_TABLE_ENTITY_PARAMS_SUCCESS:
            return { ...state, entityParams: { ...state.entityParams, [action.section]: { ...action.response } } };
        case actionType.UPDATE_DYNAMIC_TABLE_ENTITY_PARAMS_FAILURE:
            return { ...state, entityParams: { ...state.entityParams, [action.section]: { ...action.error } } };

        case actionType.CLEAR_DYNAMIC_TABLE_ENTITY_PARAMS: {
            const entityParams = { ...state.entityParams };
            (action.sections || []).forEach(section => delete entityParams[section]);
            return { ...state, entityParams };
        }

        case actionType.CLEAR_DYNAMIC_TABLE_RESPONSES:
            return {
                ...state,
                deleteDynamicTableResponse: null,
                deleteDynamicTableBandResponse: null,
                deleteDynamicTableFieldResponse: null,
                deleteDynamicTableRecordResponse: null
            };

        default:
            return state;
    }
};
